/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _useProperty3 = _interopRequireDefault(require("./useProperty"));
var _default = function _default(props, computedProps) {
  var _useProperty = (0, _useProperty3.default)(props, 'showHeader'),
    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
    computedShowHeader = _useProperty2[0],
    setShowHeader = _useProperty2[1];
  var result = {
    computedShowHeader: computedShowHeader,
    setShowHeader: setShowHeader
  };
  if (computedShowHeader) {
    result.onHeaderSortClick = function (colProps) {
      if (computedProps.toggleColumnSort) {
        computedProps.toggleColumnSort(colProps.id, colProps.defaultSortingDirection);
      }
    };
  }
  return result;
};
exports.default = _default;